import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DynamicSettings } from '@common-modules/common-persistency/models/dynamic-settings';
import { DynamicSettingsSave } from '@common-modules/common-persistency/models/dynamic-settings-save';
import { SettingsComponentType } from '@common-modules/shared/config/settings-component-type';
import { IntegrableForm, IntegrableFormParams } from '@common-modules/shared/forms/integrable-form';
import { globalUtilsHelper } from '@common-modules/shared/helpers/global-utils-helper';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { ConfigurableFilterSettings } from '../configurable-filter-settings';

@Component({
  selector: 'app-configurable-filter',
  templateUrl: './configurable-filter.component.html',
  styleUrl: './configurable-filter.component.scss',
  standalone: false
})
export class ConfigurableFilterComponent extends IntegrableForm implements OnInit {
  private _settings: ConfigurableFilterSettings;
  get settings(): ConfigurableFilterSettings {
    return this._settings;
  }
  @Input() set settings(value: ConfigurableFilterSettings) {
    this._settings = value;
    if (this.settings) {
      this.loadFromPersistency();
    }
  }
  @Input() fields: FormlyFieldConfig[];

  @Output() searchChange = new EventEmitter<any>();

  initialModel;
  model;

  private readonly _persistencyArea = 'ConfigurableFilters';

  ngOnInit(): void {}

  private loadFromPersistency(): void {
    const persistency = this.settings.persistency;
    if (persistency) {
      persistency.service
        .load(
          new DynamicSettings({
            settingArea: this._persistencyArea,
            settingKey: persistency.key,
          })
        )
        .subscribe((model) => {
          this.model = model;
          this.emitSearch(model);
        });
    }
  }

  private saveToPersistency(): void {
    const persistency = this.settings.persistency;
    if (persistency) {
      const model = this.getModel();

      persistency.service
        .save(
          new DynamicSettingsSave({
            createComponentIfNoExists: true,
            componentTypeId: SettingsComponentType.ConfigurableFilters,
            settingKey: persistency.key,
            settingArea: this._persistencyArea,
            settingValue: JSON.stringify(model),
          })
        )
        .subscribe();
    }
  }

  onSearch(): void {
    const model = this.getModel();
    this.emitSearch(model);
    this.saveToPersistency();
  }

  private emitSearch(model): void {
    this.searchChange.emit(model);
  }

  onModelChange(model): void {
    this.model = globalUtilsHelper.clone(model, true);
  }

  onIsValid(isValid: boolean): void {
    this.setIsValid(isValid);
  }

  onHasChanges(hasChanges: boolean): void {
    this.setHasChanges(hasChanges);
  }

  getModel() {
    return this.model;
  }

  setInitialModel(model: any): void {
    this.initialModel = globalUtilsHelper.clone(model, true);
  }

  setParams(params: IntegrableFormParams): void {
    this.formOptions.formState.op = params.op;
    this.formOptions = globalUtilsHelper.clone(this.formOptions);
  }

  formOptions: FormlyFormOptions = {
    formState: {},
  };
}
